import { Injectable } from '@angular/core';
import { fromEvent, map, merge, shareReplay, startWith } from 'rxjs';

export type NetworkState = 'online' | 'offline';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  state$ = merge(
    fromEvent(window, 'online').pipe(map<Event, NetworkState>(() => 'online')),
    fromEvent(window, 'offline').pipe(map<Event, NetworkState>(() => 'offline'))
  ).pipe(startWith(navigator.onLine ? 'online' : ('offline' as NetworkState)), shareReplay(1));
}
